import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CiEdit } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import LoaderMini from "../../Loader/LoaderMini";
import { fetchUserProfile } from "../../../redux/slices/userProfileSlice";
import { logout } from "../../../redux/slices/authSlice";
import saudi_flag from "../../../assets/icons/saudi_flag.webp";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUpdateProfileMutation } from "../../../redux/slices/profileSlice";

const UpdateProfile = () => {
  const dispatch = useDispatch();
  const [updateProfile, { isLoading }] = useUpdateProfileMutation();
  const [imageFile, setImageFile] = useState(null);
  const navigate = useNavigate();
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const [previewImage, setPreviewImage] = useState(userProfile?.avatar || null);
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);


  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };


  const {
    register,
    handleSubmit,
    formState: { errors }, reset
  } = useForm();

  useEffect(() => {
    if (userProfile) {
      let formattedDate = "";

      if (userProfile.date_of_birth) {
        if (userProfile.date_of_birth.includes("/")) {
          // Backend sent MM/DD/YYYY → fix it
          const [month, day, year] = userProfile.date_of_birth.split("/");
          formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        } else {
          // Already correct format (YYYY-MM-DD)
          formattedDate = userProfile.date_of_birth;
        }
      }

      reset({
        name: userProfile.name || "",
        email: userProfile.email || "",
        phone: userProfile.phone?.replace("+966", "") || "",
        gender: userProfile.gender || "",
        date_of_birth: formattedDate || "",
        bio: userProfile.bio || "",
      });

      setPreviewImage(userProfile.avatar || null);
    }
  }, [userProfile, reset]);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = async (data) => {
    data.phone = `+966${data.phone.replace(/\D/g, "")}`;

    // Fix the date format here
    let formattedDate = "";
    if (data.date_of_birth) {
      const date = new Date(data.date_of_birth);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
      const day = String(date.getDate()).padStart(2, "0");
      formattedDate = `${year}-${month}-${day}`; // YYYY-MM-DD
    }

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("phone", data.phone);
    formData.append("gender", data.gender);
    formData.append("date_of_birth", formattedDate); // use the formatted date
    formData.append("bio", data.bio);

    if (data.password) {
      formData.append("password", data.password);
    }

    if (imageFile) {
      formData.append("image", imageFile);
    }

    try {
      await updateProfile(formData).unwrap();
      await dispatch(fetchUserProfile());
      window.scrollTo({
        top: 500,
        left: 0,
        behavior: "smooth",
      });

    } catch (error) {
      console.error("Failed to update profile:", error);
      alert("Failed to update profile. Please try again.");
    }
  };

  console.log(userProfile)

  return (
    <div className="w-full flex items-start justify-start ">
      <form onSubmit={handleSubmit(onSubmit)} className=" w-full flex flex-col ">
        {/* Profile Image */}
        <div className="flex flex-col items-center lg:items-start">
          <div className="w-[9.375rem] h-[9.375rem] rounded-full 
          overflow- border mb-[45px] relative">
            {previewImage ? (
              <img
                src={previewImage}
                alt="avatar"
                className="w-full h-full object-cover rounded-full"
              />
            ) : (
              <div className="w-full h-full bg-gray-200 flex items-center 
              justify-center text-gray-500 rounded-full">
                {t("noImage")}
              </div>
            )}
            <input
              type="file"
              accept="image/*"
              id="image"
              className="hidden"
              onChange={handleImageChange}
            />
            <label
              htmlFor="image"
              className="cursor-pointer bg-[#5E00A5]  w-[3rem]
             h-[3rem] flex items-center justify-center rounded-full border-2 
             border-white absolute text-white bottom-0 right-0"
            >
              <CiEdit size={24} />
            </label>
          </div>
        </div>

        <div
          className="flex flex-col lg:flex-row items-center justify-center 
        w-full gap-2 "
        >
          {/* Name */}
          <div className="w-full mb-8">
            <label className="block text-xl w-full text-start font-medium 
            text-black mb-2 ">{t("name")} *</label>
            <input
              {...register("name", { required: t("requiredName") })}
              className="w-full px-4 py-2 border rounded-full"
              placeholder={t("yourName")}
            />
            {errors.name && (
              <p className="text-red-500 text-sm">{errors.name.message}</p>
            )}
          </div>
          {/* Phone */}
          <div className="w-full flex items-center justify-center flex-col mb-8">
            <label className="block text-xl w-full text-start font-medium 
            text-black mb-2 ">
              {t("phone")} *
            </label>
            <div className="relative w-full">
              <div
                className="absolute left-4 top-1/2 transform 
                  -translate-y-1/2 text-gray-500 text-sm flex items-center justify-center gap-1"
              >
                <img
                  src={saudi_flag}
                  alt=""
                  className="w-8 h-5 object-cover"
                />
                <p> +966 </p>
              </div>
              <input
                {...register("phone", {
                  required: t("requiredPhone"),
                  pattern: {
                    value: /^\d{7,10}$/,
                    message: t("phoneValidation"),
                  },
                })}
                placeholder="966xxxxxxxxx"
                className="w-full pl-24 px-5 py-2 border rounded-full focus:outline-none"
              />
            </div>
            {errors.phone && (
              <p className="text-red-500 w-full text-start text-sm mt-1">
                {errors.phone.message}
              </p>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="mb-8 flex flex-col w-full">
          <label className="block text-xl w-full text-start font-medium 
            text-black mb-2 ">{t("email")} *</label>
          <input
            type="email"
            {...register("email", {
              required: t("requiredEmail"),
              pattern: {
                value: /^[^@]+@[^@]+\.[^@]+$/,
                message: "Invalid email address",
              },
            })}
            className="w-full mt-1 px-4 py-2 border rounded-full"
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email.message}</p>
          )}
        </div>

        {/* Date of Birth */}
        <div className="mb-8">
          <label className="block text-xl w-full text-start font-medium 
            text-black mb-2 ">
            {t("dateOfBirth")} *
          </label>
          <input
            type="date"
            {...register("date_of_birth")}
            className="w-full mt-1 px-4 py-2 border rounded-full"
          />
        </div>

        {/* Gender */}
        <div className="mb-8 relative">
          <label className="block text-xl w-full text-start font-medium 
            text-black mb-2 ">{t("gender")} *</label>
          <select
            {...register("gender")}
            className=" appearance-none w-full mt-1 px-4 py-2 border rounded-full"
          >
            <option value="male">{t('male')}</option>
            <option value="female">{t("female")}</option>
          </select>

          <div className={`pointer-events-none absolute top-[63%] 
          ${isEng ? "right-5" : "left-5"}`}>
            <IoIosArrowDown className="text-gray-700 w-5 h-5" />
          </div>
        </div>

        {/* Bio */}
        <div className="mb-8">
          <label className="block text-xl w-full text-start font-medium 
            text-black mb-2 ">{t("bio")} *</label>
          <textarea
            {...register("bio")}
            className="w-full mt-1 px-4 py-2 border rounded-lg resize-none"
            rows="3"
            placeholder={t("tellUsAboutYourself")}
          ></textarea>
        </div>

        {/* Password */}
        <div className="mb-8">
          <label className="block text-xl w-full text-start font-medium 
            text-black mb-2 ">
            {t("newPassword")} ({t("optional")}) *
          </label>
          <input
            type="password"
            {...register("password", {
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters",
              },
            })}
            className="w-full mt-1 px-4 py-2 border rounded-full"
            placeholder={t("newPassword")}
          />
          {errors.password && (
            <p className="text-red-500 text-sm">{errors.password.message}</p>
          )}
        </div>
        <div className="flex w-full items-center justify-center gap-2 flex-col lg:flex-row">
          {/* Submit */}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full h-[3.625rem] lg:text-lg px-4 bg-blue-800 text-white 
            rounded-full hover:bg-blue-600 transition flex justify-center 
            items-center"
          >
            {isLoading ? (
              <LoaderMini color="bg-yellow-400" />
            ) : (
              t("updateProfile")
            )}
          </button>
          <button
            type="button"
            onClick={handleLogout}
            className="w-full h-[3.625rem] lg:text-lg  px-4 bg-red-500 text-white rounded-full
             hover:bg-red-700 transition flex justify-center items-center"
          >
            {t("logout")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateProfile;
